<template>
    <div class="AboutUs">
        <menuBox :step="2"></menuBox>
        <div class="about-us">
            <div class="text-box">
                <div>About Us</div>
                <p>Let the audience experience deep emotions and spiritual shock in a short period of time.</p>
            </div>
        </div>

        <div class="about-1">
            <img src="../assets/about_2.png" alt="">
            <div class="about-text">
                <div class="text-1">Our goal</div>
                <div class="text-2">Committed to the unremitting pursuit of the art of short drama</div>
                <div class="text-3">Our goal is to compete with the best in the world by creating compelling and inspiring short plays. We strive to expand the international market and work with international teams to ensure that our works are recognized globally.</div>
            </div>
        </div>

        <div class="about-2">
            <div class="about-item">
                <img src="../assets/about_3.png" alt="">
                <div class="year">10+</div>
                <div>years of experience accumulation</div>
                <p>Many cases provide reference</p>
            </div>
            <div class="about-item">
                <img src="../assets/about_4.png" alt="">
                <div class="year">100+</div>
                <div>short plays</div>
                <p>Produce short plays on various themes</p>
            </div>
            <div class="about-item">
                <img src="../assets/about_5.png" alt="">
                <div class="year">50,000+ </div>
                <div>user reviews</div>
                <p>Have a good reputation</p>
            </div>
            <div class="about-item">
                <img src="../assets/about_6.png" alt="">
                <div class="year">25</div>
                <div>teams have cooperated</div>
                <p>A trustworthy partner</p>
            </div>
        </div>

        <div class="about-3">
            <div class="title">Good reputation and recognition from many fans</div>
            <div class="msg-list">
                <div class="msg-item">
                    <p>Amazing! I'm very impressed with this company's work. Every short play made me immersed in it, and I felt the author's intention and creativity. Their reputation is absolutely well-deserved!</p>
                    <div>2024/3/20</div>
                    <img src="../assets/about_7.png" alt="">
                </div>
                <div class="msg-item">
                    <p>I have always been a big fan of this company and their work always touches my heart. Whether it's the emotionally delicate plot or the thrilling scenes, I was deeply immersed in it. Their market position has been earned entirely on their own merit!</p>
                    <div>2024/4/2</div>
                    <img src="../assets/about_8.png" alt="">
                </div>
                <div class="msg-item">
                    <p>I have always believed in the strength of this company, and their works always bring me unexpected surprises. Their good reputation and market position are entirely earned by the quality and influence of their works. I'm proud to be their biggest fan!</p>
                    <div>2024/4/10</div>
                    <img src="../assets/about_9.png" alt="">
                </div>
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>


<style lang="less" scoped>
.about-us {
    height: 458px;
    background: url(../assets/about_1.png);
    background-size: 100% 100%;

    .text-box {
        width: 450px;
        margin-left: 360px;
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;
        height: 100%;

        div {
            font-weight: bold;
            font-size: 60px;
            color: #FFFFFF;
        }

        p {
            font-weight: 500;
            font-size: 18px;
            color: #B9B9B9;
            margin-top: 20px;
        }
    }
}

.about-1 {
    padding: 150px 360px;
    display: flex;
    align-items: center;

    img {
        width: 570px;
    }

    .about-text {
        padding: 76px 40px;
        background: #F3F3F3;
        width: 610px;
        margin-left: -100px;

        .text-1 {
            font-weight: 500;
            font-size: 26px;
            color: #FF015A;
        }

        .text-2 {
            font-weight: bold;
            font-size: 36px;
            color: #333333;
            margin-top: 15px;
        }

        .text-3 {
            font-weight: 400;
            font-size: 26px;
            color: #999999;
            margin-top: 25px;
        }
    }

}

.about-2 {
    height: 400px;
    background: url(../assets/about_bg.png);
    background-size: 100% 100%;
    padding: 0px 350px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .about-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        img {
            width: 72px;
        }

        div {
            font-weight: normal;
            font-size: 18px;
            color: #37393F;
            margin-top: 12px;
        }

        p {
            font-weight: 400;
            font-size: 18px;
            color: #7D7D7D;
            margin-top: 20px;
        }

        .year {
            font-weight: bold;
            font-size: 40px;
            color: #FF015A;
            margin-top: 20px;
        }

    }
}

.about-3 {
    padding: 125px 360px;

    .title {
        font-weight: 600;
        font-size: 58px;
        color: #333333;
        text-align: center;
    }

    .msg-list {
        margin-top: 112px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .msg-item {
            width: 290px;
            height: 400px;
            padding: 40px 30px;
            background: #F3F3F3;
            position: relative;

            div {
                font-weight: 500;
                font-size: 30px;
                color: #333333;
            }

            p {
                font-weight: 400;
                font-size: 16px;
                color: #999999;
                padding: 34px 0px;
            }

            img {
                position: absolute;
                bottom: 40px;
                right: -50px;
            }
        }
    }
}
</style>